import { ReactComponent as MindyLoader } from "@/assets/images/add-ons/mindy-loader.svg";
import { Modal, Typography } from "@/components/atoms";

interface AddOnRedirectionModalProps {
  name: string;
  open: boolean;
  isActivating?: boolean;
}

export const AddOnRedirectionModal = ({ name, isActivating, open }: AddOnRedirectionModalProps) => {
  return (
    <Modal open={open} onClose={() => null} className="w-[85vw] md:w-[700px] lg:w-[700px]">
      <div className="flex flex-row gap-x-8">
        <MindyLoader className="-mt-2" />
        <div className="flex w-full flex-col">
          <Typography variant="h3">{`${isActivating ? "Enabling" : "Disabling"} ${name}`}</Typography>
          <Typography variant="paragraph">
            {isActivating ? "Hang tight, we'll redirect you shortly!" : "We're sorry to see it go. Please wait a moment."}
          </Typography>
          <div className="mt-8 h-2.5 w-full animate-pulse rounded-full bg-primary" />
        </div>
      </div>
    </Modal>
  );
};
